import { render, staticRenderFns } from "./BranchDropdown.vue?vue&type=template&id=184dcc2a"
import script from "./BranchDropdown.vue?vue&type=script&lang=js"
export * from "./BranchDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports